import * as THREE from 'three';
import { createGridTexture } from './create-grid-texture.js';
import { createStreetMaterial } from './create-street-material.js';

export function createMaterialLibrary({
   textures,
   liquidWaveMaterial,
   gridBackground,
}) {
   const groundGridTexture = createGridTexture({
      background: gridBackground,
   });
   const channelGridTexture = createGridTexture({
      background: gridBackground,
      cells: 4,
      lineWidth: 4,
      repeat: 2,
   });

   const materials = {
      BodenPlatte: new THREE.MeshStandardMaterial({
         color: 0xe8e6e7,
         map: groundGridTexture,
      }),
      MudWallCenter: new THREE.MeshPhysicalMaterial({
         map: textures.mudWallBaseColor,
         normalMap: textures.mudWallNormal,
         normalScale: new THREE.Vector2(2, 2),
         roughness: 0.5,
         specularIntensityMap: textures.mudWallSpecular,
         color: 0xfbfaf8,
         emissive: 0xe1b165,
         emissiveIntensity: 0.02,
      }),
      FluessigbodenPlane_moving: liquidWaveMaterial,
      FluessigbodenPlane: new THREE.MeshStandardMaterial({
         map: textures.concreteBaseColor,
         normalMap: textures.concreteNormal,
         roughnessMap: textures.concreteRoughness,
         roughness: 0.55,
         color: 0xffffff,
         emissive: 0xa89887,
         emissiveIntensity: 0.2,
      }),
      PileSand_01: new THREE.MeshStandardMaterial({
         map: textures.sandBaseColor,
         normalMap: textures.sandNormal,
         roughnessMap: textures.sandRoughness,
         color: 0x8e7235,
      }),
      PileSand_02: new THREE.MeshStandardMaterial({
         map: textures.sandBaseColor,
         normalMap: textures.sandNormal,
         roughnessMap: textures.sandRoughness,
         color: 0xcccccc,
      }),
      PileSand_03: new THREE.MeshStandardMaterial({
         map: textures.sandBaseColor,
         normalMap: textures.sandNormal,
         roughnessMap: textures.sandRoughness,
         color: 0xffffff,
      }),
      Kanal_main: new THREE.MeshStandardMaterial({
         color: 0xe8e6e7,
         map: channelGridTexture,
      }),
      ArbeitsraumTop: new THREE.MeshStandardMaterial({
         color: 0xe8e6e7,
         map: channelGridTexture,
      }),
      Street: createStreetMaterial(textures),
      Kies: new THREE.MeshStandardMaterial({
         map: textures.streetGravelBaseColor,
         normalMap: textures.streetGravelNormal,
         roughnessMap: textures.streetGravelRoughness,
         color: 0xffffff,
      }),
      Gras: new THREE.MeshStandardMaterial({
         map: textures.grassBaseColor,
         normalMap: textures.grassNormal,
         normalScale: new THREE.Vector2(2, 2),
         roughnessMap: textures.grassRoughness,
         color: 0xffffff,
      }),
      Kollektor: new THREE.MeshStandardMaterial({
         color: 0x93a800,
         roughness: 0.65,
         metalness: 0,
      }),
   };

   return {
      materials,
      groundGridTexture,
   };
}
